import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EmailTypes } from 'enum'
import { determineGrammaticalGender } from 'helpers/determineGrammaticalGender'

const useEmailDefaultValues = () => {
  const { t } = useTranslation()
  const tPredefinedPrefix = 'administration.monitor.sendEmail.form.predefinedV2'

  const getTexts = useCallback(
    ({
      courseName,
      emailType,
    }: {
      emailType: EmailTypes
      courseName?: string
    }) => {
      const app = t('commons.navBar.title')
      const context = determineGrammaticalGender(app)
      const options = { app, context }
      return {
        subject: t(`${tPredefinedPrefix}.${emailType}.subject`, options),
        content: t(`${tPredefinedPrefix}.${emailType}.content`, {
          courseName,
          ...options,
        }),
      }
    },
    [t]
  )
  return getTexts
}

export default useEmailDefaultValues
